const initialState = {
  data: {},
  isLoading: false,
  isError: false,
  message: "",
};

const category = (state = initialState, action) => {
  switch (action.type) {
    case "GET_CATEGORY_PENDING":
      return {
        ...state,
        data: [],
        isLoading: true,
        isError: false,
        message: "Loading...",
      };

    case "GET_CATEGORY_REJECTED":
      return {
        ...state,
        data: [],
        isLoading: false,
        isError: true,
        message: action.payload.message,
      };

    case "GET_CATEGORY_FULFILLED":
      return {
        ...state,
        data: action.payload.data.data,
        isLoading: false,
        isError: false,
        message: action.payload.data.message,
      };

    case "ADD_CATEGORY_PENDING":
      return {
        ...state,
        data: {},
        isLoading: true,
        isError: false,
        message: "Loading...",
      };

    case "ADD_CATEGORY_REJECTED":
      return {
        ...state,
        data: {},
        isLoading: false,
        isError: true,
        message: action.payload.response.data,
      };

    case "ADD_CATEGORY_FULFILLED":
      return {
        ...state,
        data: action.payload.data.data,
        isLoading: false,
        isError: false,
        message: action.payload.data.message,
      };

    default: {
      return state;
    }
  }
};

export default category;
